// Строка над блоками: «Показан май 2026: последний месяц, где есть выдачи. В октябре 2026 выдач
// ещё не было.»
//
// Вкладки «Кому выдано» и «На что потрачено» без месяца в адресе открываются не на текущем, а на
// последнем месяце, где есть данные: заказчик держит май, а октябрь ещё пуст, и экран, открытый
// на октябре, встречал человека словами «выдач не было» и пятью нажатиями назад до его денег.
//
// Но подменить месяц молча нельзя. Человек открыл вкладку «сегодня», а видит май: если экран не
// скажет, что так и задумано, это читается как «программа показала не тот месяц», и числа мая
// принимаются за октябрьские. Поэтому одна строка словами, там же, над блоками, и она говорит обе
// вещи сразу: какой месяц показан и почему не текущий.
//
// Строки нет, когда показан тот самый месяц, о котором просили: подсказке нечего сообщать. Нет её
// и когда месяц выбран человеком (стрелкой или ссылкой): это его выбор, а не догадка экрана. Это
// решает вызывающий, не показывая компонент; тут только сравнение двух месяцев на всякий случай.

import { RiInformationLine } from '@remixicon/react';

import { formatPeriodTitle, месяцВПредложном, type Period } from '@/shared/time/period';
import * as Alert from '@/shared/ui/alert';

/** О чём идёт речь, словами вкладки: что искали и чего в текущем месяце ещё не было. */
export interface ЧтоИскали {
  /** «выдачи», «выдачи или принятые расходы»: после слов «последний месяц, где есть». */
  есть: string;
  /** «выдач», «их», «принятых расходов»: в «В октябре 2026 … ещё не было». */
  небыло: string;
}

/** «Кому выдано»: реестр выдач. */
export const ЧТО_ВЫДАЧИ: ЧтоИскали = { есть: 'выдачи', небыло: 'выдач' };

/**
 * «На что потрачено» у тех, кто видит кассу: сверка месяца строится и по выдачам, и по принятым
 * расходам, и месяц без того и другого пуст.
 */
export const ЧТО_ВЫДАЧИ_И_РАСХОДЫ: ЧтоИскали = {
  есть: 'выдачи или принятые расходы',
  небыло: 'их',
};

/**
 * «На что потрачено» у тех, кому касса не выдаёт (старший объекта): выдач они не видят, и писать
 * им про выдачи значило бы говорить о том, чего на экране нет.
 */
export const ЧТО_РАСХОДЫ: ЧтоИскали = {
  есть: 'принятые расходы',
  небыло: 'принятых расходов',
};

export function ПоказанПоследнийМесяц({
  показан,
  запрошен,
  что,
}: {
  /** Месяц, данные которого на экране: берётся из ответа сервера, а не из адреса. */
  показан: Period;
  /** Месяц, на котором экран открылся бы сам: текущий. */
  запрошен: Period;
  что: ЧтоИскали;
}) {
  if (показан.year === запрошен.year && показан.month === запрошен.month) {
    return null;
  }
  return (
    <Alert.Root variant='lighter' status='information' size='xsmall' role='note'>
      <Alert.Icon as={RiInformationLine} />
      <span>
        Показан {formatPeriodTitle(показан).toLowerCase()}: последний месяц, где есть {что.есть}. В{' '}
        {месяцВПредложном(запрошен)} {что.небыло} ещё не было.
      </span>
    </Alert.Root>
  );
}
